import { TrainingCourseSectionState } from "./training-course-section-state";
import { TrainingCourseSection } from "./training-course-section.model";
import { TrainingCourseState } from "./training-course-state";
import { TrainingCourse } from "./training-course.model";
import { TrainingType } from "./training-type";
import { UserAbridged } from "../abridged/user-abridged.model";

export class TrainingCourseForUser {
  workerId: number;
  contractorId: number;
  contractorName: string;
  workerUserCourseId: number;
  userCourseId: number;
  courseProgress: TrainingCourseState;
  expiryDate: Date;
  course: TrainingCourse;
  lastModifiedDate: Date;
  // used in list view
  hasOneInProgress: boolean;
  expired: boolean;

  public deserialize(input: any): this {
    if(input.workerUser){
      this.workerId = input.workerUser.id;
    } else {
      this.contractorId = input.maintenance.id;
      this.contractorName = input.maintenance.name;
    }
    this.workerUserCourseId = input.id;
    this.userCourseId = input.id;
    this.courseProgress = input.courseProgress;
    this.expiryDate = input.expiryDate ? new Date(input.expiryDate) : null;
    this.course = (new TrainingCourse()).deserialize(input.course);
    this.lastModifiedDate = new Date(input.lastModifiedDate);

    return this;
  }

  public getSectionById(sectionId): TrainingCourseSection {
    return this.course.sections.find(section => section.courseSectionId === sectionId);
  }

  public getFirstIncompleteSection() {
    return this.course.sections.find(section => {
      return section.sectionStatus !== TrainingCourseSectionState.Completed;
    });
  }

  // creates a 'not started' course for lists where there are no records of the user course yet
  // not valid in all situations, only useful as a placeholder.
  public static createInductionPlaceholder(params: {
    workerUserId: number,
    inductionCourse: any,
    siteOwner: any,
    siteNames: string[],
  }): TrainingCourseForUser {
    const courseForUser = new TrainingCourseForUser();

    courseForUser.workerId = params.workerUserId;
    courseForUser.courseProgress = TrainingCourseState.NotStarted;
    courseForUser.expiryDate = null;
    courseForUser.hasOneInProgress = false;
    courseForUser.expired = false;

    const trainingCourse = new TrainingCourse();
    trainingCourse.trainingId = params.inductionCourse.id;
    trainingCourse.trainingName = params.inductionCourse.name;
    trainingCourse.description = params.inductionCourse.description;
    trainingCourse.validForMonths = params.inductionCourse.validForMonths;
    trainingCourse.type = TrainingType.Induction;
    trainingCourse.sections = [];
    trainingCourse.sites = params.siteNames;
    trainingCourse.siteIds = [];
    trainingCourse.siteOwner = (new UserAbridged()).deserialize(params.siteOwner);

    courseForUser.course = trainingCourse;

    return courseForUser;
  }
};
